import styled from '@emotion/styled';
import { Container, SkeletonBox } from '@presentation/components';
import { mediaQuery } from '@presentation/styles';

export const PageContainer = styled(Container)`
  margin-bottom: 100px;
  ${mediaQuery('small')} {
    margin-bottom: 50px;
  }
`;

export const SideSkeletonBox = styled(SkeletonBox)`
  width: 100%;
  height: 400px;
  border-radius: 15px;
  box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.06);
`;

export const SectionTitleSkeleton = styled(SkeletonBox)`
  display: block;
  height: 75px;
  margin-bottom: 15px;
`;

export const RelatedSectionTitleSkeleton = styled(SectionTitleSkeleton)`
  max-width: 600px;
`;

export const TopMargin = styled.div`
  margin-top: 80px;
`;

export const SidePadding = styled.div`
  padding-left: 15px;
  padding-right: 15px;
`;

export const SideSkeletonImage = styled(SkeletonBox)``;

export const Header = styled(SkeletonBox)`
  height: 200px;
  width: 100%;
`;

export const SideItemWrapper = styled.div`
  display: flex;
  margin-bottom: 5px;
`;

export const MainImageSkeleton = styled(SkeletonBox)`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
`;
